const screenshotsPath = (analysisId: string) => `/internal/analysis/${encodeURIComponent(analysisId)}/screenshots`

export const getAnalysisScreenshotsPath = (analysisId: string) => screenshotsPath(analysisId)

export const getAnalysisScreenshotsUploadPath = (analysisId: string) => `${screenshotsPath(analysisId)}/upload`

export const getAnalysisScreenshotsEditPath = (analysisId: string, indices: number[]) => `${screenshotsPath(analysisId)}/edit?indices=${indices.join(',')}`
